import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Radio from "@material-ui/core/Radio";
import Chip from "@material-ui/core/Chip";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import PersonalIcon from "@material-ui/icons/Person";
import SharedIcon from "@material-ui/icons/People";
import GlobalIcon from "@material-ui/icons/Public";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import CloseableDialog from "../dialog/CloseableDialog";
import ConfigurationProfileEditDialog from "./ConfigurationProfileEditDialog";
import * as Utils from "../../Utils";
import { abbreviateString } from "../../Utils";
import * as Config from "../utils/ConfigurationRegistry";
import { useConfigProfile } from "./ConfigurationProfile";
import YesNoDialog from "../dialog/YesNoDialog";
import ErrorMessageDialog from "../dialog/ErrorMessageDialog";
import TextField from "@material-ui/core/TextField";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: "100%"
    },
    avatar: {
      backgroundColor: "rgba(0, 0, 0, 0)"
    }
  };
});
var PERMISSION_PERSONAL = "Personal";
var PERMISSION_GLOBAL = "Global";
var PERMISSION_TEAM = "Team";
var PERMISSION_HELPER_TEXT = {
  Personal: "Only visible to the user who creates it",
  Global: "Visible to all users in the company",
  Team: "Users in the same team share definitions"
};
var ConfigurationProfileDialog = function ConfigurationProfileDialog(_ref) {
  var open = _ref.open,
    handleAddProfile = _ref.handleAddProfile,
    handleClose = _ref.handleClose,
    handleEditProfile = _ref.handleEditProfile,
    readOnly = _ref.readOnly,
    profileLabel = _ref.profileLabel,
    handleNotification = _ref.handleNotification,
    PermissionConfigurationComponent = _ref.PermissionConfigurationComponent,
    doNotWarnUserOfPendingEdits = _ref.doNotWarnUserOfPendingEdits,
    saveConfigurationTrigger = _ref.saveConfigurationTrigger;
  var classes = useStyles();
  var RedTextTypography = withStyles({
    root: {
      color: "#9e0404"
    }
  })(Typography);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedProfileName = _React$useState2[0],
    setSelectedProfileName = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    profiles = _React$useState4[0],
    setProfiles = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    filteredProfiles = _React$useState6[0],
    setFilteredProfiles = _React$useState6[1];
  var _useConfigProfile = useConfigProfile(),
    _useConfigProfile2 = _slicedToArray(_useConfigProfile, 2),
    configProfile = _useConfigProfile2[0],
    setConfigProfile = _useConfigProfile2[1];
  var _React$useState7 = React.useState(""),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    searchText = _React$useState8[0],
    setSearchText = _React$useState8[1];
  var _React$useState9 = React.useState(null),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    profilePendingEdit = _React$useState10[0],
    setProfilePendingEdit = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    pendingEditsWarningOpen = _React$useState12[0],
    setPendingEditsWarningOpen = _React$useState12[1];
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    profileToLoadPendingWarningConfirmation = _React$useState14[0],
    setProfileToLoadPendingWarningConfirmation = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    pendingDeleteConfirmationOpen = _React$useState16[0],
    setPendingDeleteConfirmationOpen = _React$useState16[1];
  var _React$useState17 = React.useState(null),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    profilePendingDelete = _React$useState18[0],
    setProfilePendingDelete = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    pendingSaveConfirmationOpen = _React$useState20[0],
    setPendingSaveConfirmationOpen = _React$useState20[1];
  var _React$useState21 = React.useState(null),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    profilePendingSave = _React$useState22[0],
    setProfilePendingSave = _React$useState22[1];
  var _React$useState23 = React.useState(null),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    lastLoadedProfileName = _React$useState24[0],
    setLastLoadedProfileName = _React$useState24[1];
  var _React$useState25 = React.useState(null),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    lastLoadedProfileNamePendingWarningConfirmation = _React$useState26[0],
    setLastLoadedProfileNamePendingWarningConfirmation = _React$useState26[1];
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    showCannotSaveDifferentDefinition = _React$useState28[0],
    setShowCannotSaveDifferentDefinition = _React$useState28[1];
  var _React$useState29 = React.useState(false),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    showCannotSaveWithoutLoad = _React$useState30[0],
    setShowCannotSaveWithoutLoad = _React$useState30[1];
  var _React$useState31 = React.useState(false),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    showCannotOverwriteProfile = _React$useState32[0],
    setShowCannotOverwriteProfile = _React$useState32[1];
  React.useEffect(function () {
    if (saveConfigurationTrigger) {
      onSave(getSelectedProfile(lastLoadedProfileName), false);
    }
  }, [saveConfigurationTrigger]);
  var fixCaseForComparison = function fixCaseForComparison(str) {
    return str;
  };
  React.useEffect(function () {
    if (open) {
      refreshProfiles();
      setSelectedProfileName(configProfile && configProfile.name ? configProfile.name : null);
    }
  }, [open]);
  React.useEffect(function () {
    console.log("Search text changed: " + searchText);
    if (searchText) {
      var searchTextLowerCase = searchText.toLowerCase();
      var filterElements = function filterElements(elements) {
        return elements.map(function (profile) {
          return _objectSpread({}, profile); // Clone it
        }).filter(function (profile) {
          return profile.name.toLowerCase().indexOf(searchTextLowerCase) >= 0;
        });
      };
      setFilteredProfiles(filterElements(profiles));
    } else {
      setFilteredProfiles(profiles);
    }
  }, [searchText]);
  var onSearchChange = function onSearchChange(event) {
    setSearchText(event.target.value);
  };
  var handleProfileSelection = function handleProfileSelection(profileName, profile) {
    setLastLoadedProfileName(profileName);
    setConfigProfile(profile);
    handleClose();
  };
  var refreshProfiles = function refreshProfiles() {
    Utils.fetchData("configuration/profiles").then(function (data) {
      setProfiles(data.profiles);
      setFilteredProfiles(data.profiles);
    }).catch(function (error) {
      handleNotification({
        success: false,
        messages: ["Internal server error"],
        open: true
      });
    });
  };
  var onEditProfile = function onEditProfile(profile) {
    if (handleEditProfile) {
      handleEditProfile(profile);
    } else {
      setProfilePendingEdit(true);
    }
  };
  var onDeleteProfile = function onDeleteProfile(profile) {
    setPendingDeleteConfirmationOpen(true);
    setProfilePendingDelete(profile);
  };
  var onDeleteConfirmed = function onDeleteConfirmed(approved) {
    var deleteProfile = profilePendingDelete;
    setPendingDeleteConfirmationOpen(false);
    setProfilePendingDelete(null);
    if (approved) {
      Utils.fetchData("configuration/delete?profile=" + JSON.stringify(deleteProfile), {
        method: "post"
      }).then(function (data) {
        data.open = true;
        handleNotification(data);
        setProfilePendingEdit(false);
        setSelectedProfileName(null);
        if (configProfile === deleteProfile) {
          setConfigProfile({});
        }
        refreshProfiles();
      }).catch(function (response) {
        Utils.getErrorMessage(response, profileLabel + " deletion failed.").then(function (message) {
          return handleNotification({
            success: false,
            messages: [message],
            open: true
          });
        });
      });
    }
  };
  var onSaveAs = function onSaveAs() {
    setSelectedProfileName({});
    setProfilePendingEdit(true);
  };
  var onCloseEditedProfile = function onCloseEditedProfile() {
    setProfilePendingEdit(false);
  };
  var onNewDefinition = function onNewDefinition() {
    onLoadProfile(null, {});
  };
  var onLoadProfile = function onLoadProfile(profileName, profile) {
    if (!doNotWarnUserOfPendingEdits && Config.isEdited()) {
      setLastLoadedProfileNamePendingWarningConfirmation(profileName);
      setProfileToLoadPendingWarningConfirmation(profile);
      setPendingEditsWarningOpen(true);
    } else {
      handleProfileSelection(profileName, profile);
    }
  };
  var onWarningMessageAcknowledges = function onWarningMessageAcknowledges(approved) {
    if (approved) {
      handleProfileSelection(lastLoadedProfileNamePendingWarningConfirmation, profileToLoadPendingWarningConfirmation);
    }
    setPendingEditsWarningOpen(false);
    setProfileToLoadPendingWarningConfirmation({});
  };
  var getSelectedProfile = function getSelectedProfile(findProfileName) {
    var useProfileName = findProfileName ? findProfileName : selectedProfileName;
    return profiles.find(function (profile) {
      return fixCaseForComparison(profile.name) === fixCaseForComparison(useProfileName);
    });
  };
  var onSave = function onSave(profile) {
    var checkLastLoadedMatchesProfile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (checkLastLoadedMatchesProfile) {
      if (lastLoadedProfileName) {
        if (fixCaseForComparison(selectedProfileName) !== fixCaseForComparison(lastLoadedProfileName)) {
          setShowCannotSaveDifferentDefinition(true);
        } else {
          setProfilePendingSave(profile);
          setPendingSaveConfirmationOpen(true);
        }
      } else {
        setShowCannotSaveWithoutLoad(true);
      }
    } else {
      if (lastLoadedProfileName) {
        setSelectedProfileName(lastLoadedProfileName);
        setProfilePendingSave(profile);
        setPendingSaveConfirmationOpen(true);
      } else {
        setShowCannotSaveWithoutLoad(true);
      }
    }
  };
  var onSaveConfirmed = function onSaveConfirmed(approved) {
    if (approved) {
      doSaveProfile(profilePendingSave);
    }
    setPendingSaveConfirmationOpen(false);
    setProfilePendingSave(null);
  };

  /**
   * This method checks if the profile name is valid and then calls the method that actually saves it.
   */
  var onApplyProfileEdits = function onApplyProfileEdits(profile) {
    var name = profile.name;
    if (lastLoadedProfileName) {
      //
      // A profile has been loaded - let the user save it if it was not renamed, or if he used the same name
      //
      if (fixCaseForComparison(name) === fixCaseForComparison(lastLoadedProfileName)) {
        setProfilePendingSave(profile);
        setPendingSaveConfirmationOpen(true);
        return;
      } else {
        var _iterator = _createForOfIteratorHelper(profiles),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var checkProfile = _step.value;
            if (checkProfile && checkProfile.name && fixCaseForComparison(checkProfile.name) === fixCaseForComparison(name)) {
              setShowCannotOverwriteProfile(true);
              return;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    } else {
      //
      // A profile has not been loaded - make sure the user is not using an existing profile name
      //
      var _iterator2 = _createForOfIteratorHelper(profiles),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _checkProfile = _step2.value;
          if (_checkProfile && _checkProfile.name && fixCaseForComparison(_checkProfile.name) === fixCaseForComparison(name)) {
            setShowCannotOverwriteProfile(true);
            return;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    //
    // Everything passes, profile can be saved
    doSaveProfile(profile);
  };
  var doSaveProfile = function doSaveProfile(profile) {
    Utils.fetchData("configuration/save?profile=" + JSON.stringify(profile), {
      method: "post",
      body: JSON.stringify({
        values: Config.buildConfigurationValueDtos()
      })
    }).then(function (data) {
      setProfilePendingEdit(false);
      data.open = true;
      handleNotification(data);
      Config.setConfigurationValues(data.values);
      handleProfileSelection(profile.name, _objectSpread({
        doNotReloadConfigurationValues: true
      }, profile));
      refreshProfiles();
    }).catch(function (response) {
      Utils.getErrorMessage(response, profileLabel + " saving failed.").then(function (message) {
        return handleNotification({
          success: false,
          messages: [message],
          open: true
        });
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", null, profilePendingEdit && /*#__PURE__*/React.createElement(ConfigurationProfileEditDialog, {
    profile: getSelectedProfile(),
    profileLabel: profileLabel,
    handleClose: onCloseEditedProfile,
    handleSuccess: function handleSuccess(profile) {
      return onApplyProfileEdits(profile);
    },
    PermissionConfigurationComponent: PermissionConfigurationComponent
  }), /*#__PURE__*/React.createElement(ErrorMessageDialog, {
    title: "Cannot overwrite definition",
    description: "You were editing definition '" + lastLoadedProfileName + "'" + " but tried to save it as definition '" + selectedProfileName + "'. " + "Please select the definition  '" + lastLoadedProfileName + "' and try again.",
    open: showCannotSaveDifferentDefinition,
    style: {
      zIndex: 1301
    },
    handleClose: function handleClose() {
      return setShowCannotSaveDifferentDefinition(false);
    }
  }), /*#__PURE__*/React.createElement(ErrorMessageDialog, {
    title: "Cannot overwrite definition",
    description: "The definition already exists. Please use a different definition name.",
    open: showCannotOverwriteProfile,
    style: {
      zIndex: 1306
    },
    handleClose: function handleClose() {
      return setShowCannotOverwriteProfile(false);
    }
  }), /*#__PURE__*/React.createElement(ErrorMessageDialog, {
    title: "No profile was loaded",
    description: "No profile was loaded. You can only use the [Save As] button if no profile has been loaded.",
    open: showCannotSaveWithoutLoad,
    style: {
      zIndex: 1302
    },
    handleClose: function handleClose() {
      return setShowCannotSaveWithoutLoad(false);
    }
  }), /*#__PURE__*/React.createElement(YesNoDialog, {
    title: "Delete profile?",
    description: "Are you sure want to delete profile '" + selectedProfileName + "'?",
    open: pendingDeleteConfirmationOpen,
    style: {
      zIndex: 1303
    },
    handleYes: function handleYes() {
      return onDeleteConfirmed(true);
    },
    handleNo: function handleNo() {
      return onDeleteConfirmed(false);
    }
  }), /*#__PURE__*/React.createElement(YesNoDialog, {
    title: "Abandon pending changes?",
    description: "Are you sure you'd like to discard pending changes?",
    open: pendingEditsWarningOpen,
    style: {
      zIndex: 1304
    },
    handleYes: function handleYes() {
      return onWarningMessageAcknowledges(true);
    },
    handleNo: function handleNo() {
      return onWarningMessageAcknowledges(false);
    }
  }), /*#__PURE__*/React.createElement(YesNoDialog, {
    title: "Save pending changes?",
    description: "Are you sure you'd like to save pending changes to profile '" + lastLoadedProfileName + "'?",
    open: pendingSaveConfirmationOpen,
    style: {
      zIndex: 1305
    },
    handleYes: function handleYes() {
      return onSaveConfirmed(true);
    },
    handleNo: function handleNo() {
      return onSaveConfirmed(false);
    }
  }), /*#__PURE__*/React.createElement(CloseableDialog, {
    title: profileLabel,
    open: open,
    maxWidth: "sm",
    handleClose: handleClose
  }, /*#__PURE__*/React.createElement(DialogContent, {
    dividers: true
  }, lastLoadedProfileName ? /*#__PURE__*/React.createElement(DialogContentText, null, "Loaded Definition: ", lastLoadedProfileName, Config.isEdited() && /*#__PURE__*/React.createElement(Tooltip, {
    title: "There are pending changes"
  }, /*#__PURE__*/React.createElement(RedTextTypography, {
    variant: "body"
  }, " *"))) : /*#__PURE__*/React.createElement(DialogContentText, null, "Blank Definition", Config.isEdited() && /*#__PURE__*/React.createElement(Tooltip, {
    title: "There are pending changes"
  }, /*#__PURE__*/React.createElement(RedTextTypography, {
    variant: "body"
  }, " *"))), /*#__PURE__*/React.createElement(DialogContentText, null, "Select a ", profileLabel), /*#__PURE__*/React.createElement("p", null), /*#__PURE__*/React.createElement(TextField, {
    size: "medium",
    label: "Search...",
    type: "text",
    value: searchText,
    onChange: onSearchChange
  }), /*#__PURE__*/React.createElement(List, {
    className: classes.root
  }, /*#__PURE__*/React.createElement(ListItem, {
    autoFocus: true,
    button: true,
    onClick: handleAddProfile ? handleAddProfile : onNewDefinition
  }, /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, null, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(ListItemText, {
    primary: "Blank Definition"
  })), filteredProfiles.map(function (profile, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      onClick: function onClick() {
        return setSelectedProfileName(profile.name);
      }
    }, profile.permission && profile.permission.name === PERMISSION_TEAM && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
      title: PERMISSION_HELPER_TEXT[PERMISSION_TEAM]
    }, /*#__PURE__*/React.createElement(SharedIcon, {
      className: classes.menuIcon
    }))), profile.permission && profile.permission.name === PERMISSION_GLOBAL && /*#__PURE__*/React.createElement(Tooltip, {
      title: PERMISSION_HELPER_TEXT[PERMISSION_GLOBAL]
    }, /*#__PURE__*/React.createElement(GlobalIcon, {
      className: classes.menuIcon
    })), profile.permission && profile.permission.name === PERMISSION_PERSONAL && /*#__PURE__*/React.createElement(PersonalIcon, {
      title: PERMISSION_HELPER_TEXT[PERMISSION_PERSONAL]
    }, /*#__PURE__*/React.createElement(SharedIcon, {
      className: classes.menuIcon
    })), /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
      className: classes.avatar
    }, /*#__PURE__*/React.createElement(Radio, {
      color: "primary",
      checked: fixCaseForComparison(profile.name) === fixCaseForComparison(selectedProfileName),
      value: "a",
      name: "dot",
      inputProps: {
        "aria-label": "A"
      }
    }))), /*#__PURE__*/React.createElement(ListItemText, {
      primary: profile.name,
      secondary: /*#__PURE__*/React.createElement(React.Fragment, null, profile.notes, profile.permission && profile.permission.name === PERMISSION_TEAM && Array.isArray(profile.permission.value) && profile.permission.value.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
        style: {
          marginTop: 2
        }
      }, profile.permission.value.map(function (item) {
        return /*#__PURE__*/React.createElement(Chip, {
          label: abbreviateString(item, 10),
          style: {
            marginRight: 2,
            marginBottom: 2
          },
          variant: "outlined"
        });
      }))))
    })), /*#__PURE__*/React.createElement(Divider, {
      variant: "inset",
      component: "li",
      light: true
    }));
  }))), /*#__PURE__*/React.createElement(DialogActions, null, !readOnly && /*#__PURE__*/React.createElement(Tooltip, {
    title: "Delete"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "delete",
    className: classes.margin,
    disabled: !Boolean(selectedProfileName),
    onClick: function onClick() {
      return onDeleteProfile(getSelectedProfile());
    }
  }, /*#__PURE__*/React.createElement(DeleteIcon, null)))), /*#__PURE__*/React.createElement(Tooltip, {
    title: "Edit"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "edit",
    className: classes.margin,
    disabled: !Boolean(selectedProfileName),
    onClick: function onClick() {
      onEditProfile(getSelectedProfile());
    }
  }, /*#__PURE__*/React.createElement(EditIcon, null)))), !readOnly && /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: function onClick() {
      return onSaveAs();
    }
  }, "Save As"), !readOnly && /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    disabled: !Boolean(selectedProfileName) || !Config.isEdited(),
    onClick: function onClick() {
      return onSave(getSelectedProfile());
    }
  }, "Save"), /*#__PURE__*/React.createElement(Button, {
    disabled: !Boolean(selectedProfileName),
    onClick: function onClick() {
      return onLoadProfile(selectedProfileName, getSelectedProfile());
    },
    color: "primary"
  }, "Load"))));
};
export default ConfigurationProfileDialog;